var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-user-form',{attrs:{"add-user-function":"addEshopUser","link-back":"eshop-user-list","new-title":"Nový uživatel","title":"Uživatel"}}),(_vm.$route.params.id)?_c('employee-reservations-overview'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }